<template>
  <div class= "about-page">

   <div class = "img-header">
     <p class = "about" style = "font-size: 30px;">World Class Services</p>
      <p class = "about" style="text-align: center;">
       We help businesses and organizations build world class solutions tailored for their specific need while rendering top notch quality services.

        </p>
              <router-link :to="{ name: 'Contact' }">

         <a class="btn btn-new btn-xl js-scroll-trigger" href="#services"
                style = "background-color: #A31B1F ; color : #FFFFFF"
                
                >Learn more</a
              > 
                      </router-link>
        

    </div>
    <div style = "padding: 100px">
    <div >
        
            <div class="container-fluid" style = "padding: 0 100px 0 100px">
                      <div class="first-row row">
                        <div class="col">
                            <div class="row">
                              <div class="col-lg-6 col-md-6 col-sm-6 py-3">
                                    <div class="missions">
        <p style="color: #A31B1F ; font-weight: bold ; font-size: 24px">
Software development        </p>
        <p>
            We work with you to identify your business challenges and proffer solutions via software engineering.
          </p>                                    </div>
                              </div>
                              <div class="col-lg-6 col-md-6 col-sm-6 py-3">
                               <div class="missions">
        <p style="color: #A31B1F ; font-weight: bold ; font-size: 24px">
          Business development
        </p>
        <p>
            We provide sustainable business solutions models that can helps your software application. 
            We offer this through careful business research and business risk analysis.
         </p>                                    </div>
                          </div>
              
                
                            </div>
                        </div>
                      
                      </div>
                    </div> 

            <div class="container-fluid" style = "padding: 0 100px 0 100px">
                      <div class="first-row row">
                        <div class="col">
                            <div class="row">
                              <div class="col-lg-6 col-md-6 col-sm-6 py-3">
                                    <div class="missions">
        <p style="color: #A31B1F ; font-weight: bold ; font-size: 24px">
            Social enterprise development
    </p>
        <p>
            This is what we are made for, we provide top notch social enterprise solutions on a one-off basis or on an investment basis.
          </p>                                    </div>
                              </div>
                              <div class="col-lg-6 col-md-6 col-sm-6 py-3">
                               <div class="missions">
        <p style="color: #A31B1F ; font-weight: bold ; font-size: 24px">
          System Hardware Integration
        </p>
        <p>
         We partner with Original equipment manufacturer (OEM) to deploy relevant hardware ecosystem to enhance full system integration
         </p>                                    </div>
                          </div>
              
                
                            </div>
                        </div>
                      
                      </div>
                    </div> 
      </div>



</div>

</div>
</template>

<style>
.about-page {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}
.about{
display: flex;
  align-items: center;
  justify-content: center;
font: normal normal normal 24px/35px Prompt;font: normal normal normal 26px/45px Prompt;
font-weight: bold;
width: 50vw;
letter-spacing: 0px;
color: #FFFFFF;
opacity: 1;
}
#para {
  color: #2D2D2D
}
.brand-area {
        display: flex;
        justify-content: center;
    }
.img-header {
  width: 100%;
  display: flex;
  flex-direction: column;
  padding: 45px;
  justify-content: center;
  align-items: center;
  height: 700px;
  background-attachment: fixed;
  background-position: center; 
  position: relative;
  background-repeat: no-repeat;
  background: linear-gradient( rgba(0, 0, 0, 0.7), rgba(0, 0, 0, 0.7) ), url('../assets/img/Service.png'); 
      background-size: cover;

}

.missions{
  width: 450px;
  padding: 15px;
  color: #2D2D2D;
  font-size: 16px;
  height:   200px;
  background: #FFFFFF 0% 0% no-repeat padding-box;
box-shadow: 0px 8px 24px #0000000D;
border-radius: 15px;
opacity: 1;
display: flex;
align-items: center;
flex-direction: column;
justify-content: center;

}
.business{
  display: flex;
  align-items: center;
  justify-content: center;
  width: 280px;
  padding: 70px;
  color: #2D2D2D;
  font-size: 16px;
  background: #FFFFFF 0% 0% no-repeat padding-box;
box-shadow: 0px 8px 24px #0000000D;
border-radius: 15px;
opacity: 1;
height: 185px;
text-align: center;

}

.touch{
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  padding: 15px;
  width: 90vw;
  color: #2D2D2D;
  font-size: 16px;
  background: #FFFFFF 0% 0% no-repeat padding-box;
box-shadow: 0px 8px 24px #0000000D;
border-radius: 15px;
opacity: 1;
height: 185px;
text-align: center;

}

footer {
  width:100vw
}
body {
  background: black;
}
</style>

<script>
    import router from '../router'

    export default {
        name: 'Services',
        methods: {
            navigate() {
                router.push({ name: "Services" });
            }
        }
    }
</script>

